export default {
	putLogged(context, payload) {
		context.commit('PUT_LOGGED', payload);
	}, putUserId(context, payload) {

		window.sessionStorage.setItem('Schoolastic/Portal/User', payload);
		context.commit('PUT_USER_ID', payload);

	}
};



// WEBPACK FOOTER //
// ./sources/domains/logged/actions.js